export default (props) => {
  return [
    {
      name: "Ativo",
      options: {
        filter: false,
        download: false,
        customBodyRender: props.renderAtivo,
      }
    },
    {
      name: "Ativo",
      options: {
        filter: false,
        download: true,
        display: false
      }
    },
    "Código", 
    "Nome", 
    "E-mail", 
    {
      name: "Tipo de Acesso",
      options: {
        filter: false,
        download: false,
        customBodyRender: props.renderTipoAcesso,
      }
    },
    {
      name: "Permissão",
      options: {
        filter: false,
        download: true,
        display: false
      }
    },
    // {
    //     name: "Tipo de Rotação",
    //     options: {
    //       filter: false,
    //       download: false,
    //       customBodyRender: props.renderTipoRotacao,
    //     }
    // },
  ];
};